module.exports = __webpack_public_path__ + "img/video-page.2a621a97.png";